import { HttpRequest, HttpMethod } from "./http";

class CustomerProvider extends HttpRequest {
    CustomerList(params) {
        return this.request(HttpMethod.Get,`/api/v1/customers`, params);
    }

    CustomerCreate(params) {
        return this.request(HttpMethod.Post, "/api/v1/customers", params);
    }

    // UpdateCustomer
	CustomerUpdate(id,params) {
		return this.request(HttpMethod.Put,`/api/v1/customers/${id}`,params );
	}

	CustomerUpdateStatus(id,params) {
		return this.request(HttpMethod.Put,`/api/v1/customers/${id}/status`,params );
	}


    CustomerDelete(id) {
        return this.request(HttpMethod.Delete, `/api/v1/customers/${id}`);
    }

    CustomerAddressUpdate(id,params) {
        return this.request(HttpMethod.Put, `/api/v1/customers/address/${id}`, params);
    }

    CustomerAddressDelete(id) {
        return this.request(HttpMethod.Delete, `/api/v1/customers/address/${id}`);
    }
}

export default CustomerProvider;
